import React from 'react';
import MenuPromoModal from '../MenuPromoModal/MenuPromoModal';
import {ONLINE_MATCH_PROMO_IMAGE_PATH} from '../OnlineMatchPromoModal/OnlineMatchPromoModal';

const PAGE_ID = 'RankedMatchPromoModal';

/**
 * Приглашение в первый рейтинговый матч (главное меню): сетевой матч игрок
 * уже сыграл, рейтингового — нет. Награды в рейтинге богаче и растут с
 * лигой, а терять нечего — стартовый рейтинг 0 и ниже не падает.
 *
 * Когда и кому показывать, решает меню (см. resolveRankedMatchPromoReason и
 * rankedMatchPromoStorage). Кнопка ведет ровно туда же, куда кнопка
 * «Рейтинговый матч» самого меню (onRankedGame — тот же обработчик): если
 * фракций меньше четырех, игрок увидит ту же модалку «Недостаточно фракций»
 * — с подсказкой про бесплатную фракцию по акции (см. NotEnoughFactionsModal).
 * Картинка — та же, что у приглашения после обучения
 */
const RankedMatchPromoModal = ({reason, onRankedGame, onClose}) => (
  <MenuPromoModal
    pageId={PAGE_ID}
    reason={reason}
    title={'Пора в рейтинг!'}
    imagePath={ONLINE_MATCH_PROMO_IMAGE_PATH}
    imageAlt={'Рейтинговый матч'}
    /* Цвет — как у кнопки рейтингового матча в меню, без иконки лиги:
       подпись длиннее, и на узком экране она заезжала бы под иконку */
    action={{
      buttonId: 'ranked_game',
      label: 'В рейтинговый матч',
      className: 'main-menu-button_rating',
      onClick: onRankedGame,
    }}
    onClose={onClose}
  >
    <p className={'menu-promo-modal_text'}>
      Ты уже сражался с реальными игроками — самое время испытать себя
      {' '}в <span className={'text-coins'}>рейтинговом матче</span>!
    </p>

    <p className={'menu-promo-modal_text'}>
      Награды там <span className={'text-coins'}>заметно богаче</span> и растут с каждой лигой.
      Опасаться нечего: стартовый рейтинг у всех <span className={'text-rating'}>0</span>, и ниже
      он не опустится даже после поражения — так что стоит попробовать!
    </p>
  </MenuPromoModal>
);

export default RankedMatchPromoModal;
